// extracted by mini-css-extract-plugin
export default {"task":"TaskItem_task__JqqTR"};